var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCtaHandLeft = function SvgCtaHandLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 315 307"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BB6BD9",
    d: "m234.258 137.045 58.211-78.835L213.635 0l-58.212 78.834z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#82D8F6",
    strokeLinecap: "round",
    strokeWidth: 3.043,
    d: "M23.112 103.138c8.752 3.406 42.832 19.543 52.496 16.665 14.548-4.332 19.761-19.634 26.654-32.146 9.401-17.065 32.339-32.675 51.44-35.888 33.248-5.592 64.414 5.836 17.202 23.957-29.628 11.372-38.478 37.868-13.565 48.991 7.24 3.233 15.382 5.978 23.129 7.61 8.44 1.777 14.554 1.414 22.794.57 13.064-1.339 28.901-10.989 37.565-20.53 7.386-8.134 5.742-23.823 11.903-30.054 21.267-21.508 25.589 19.172 11.631 42.849-17.004 28.843-36.592 40.177-72.07 40.158M262.055 144.879c-1.212 15.843-6.623 45.631-46.03 52.538"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#82D8F6",
    strokeLinecap: "round",
    strokeWidth: 3.043,
    d: "M267.489 119.289c-1.495 15.818-4.597 29.492-16.203 40.275-11.497 10.682-26.743 19.32-42.277 20.754M22.956 103.119 3.448 151.64c78.515 56.804 166.32 54.469 248.211 85.031 17.402 8.103 21.589-16.021-2.332-27.535l-32.829-11.559"
  })));
};
export default SvgCtaHandLeft;